(() => {
  if (window.BMVolumePedalLandingInitialized) return;
  window.BMVolumePedalLandingInitialized = true;

  const syncProductForm = (select, source = 'initial') => {
    const landing = select.closest('[data-bm-lp]');
    if (!landing) return;
    const option = select.options[select.selectedIndex];
    if (!option) return;

    const available = option.dataset.available === 'true';
    landing.querySelectorAll('[data-bm-lp-price]').forEach((price) => {
      price.textContent = option.dataset.price;
    });
    landing.querySelectorAll('[data-bm-lp-add]').forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? button.dataset.bmLpDefaultLabel || 'Add to cart' : 'Sold out';
    });
    landing.querySelectorAll('[data-bm-lp-status]').forEach((status) => {
      status.textContent = available ? `${option.textContent.trim()} is available.` : `${option.textContent.trim()} is sold out.`;
    });
    landing.querySelectorAll('[data-bm-lp-variant-id]').forEach((input) => {
      input.value = option.value;
    });

    const heroImage = landing.querySelector('.bm-lp__hero-image');
    const imageSyncMode = landing.dataset.bmLpSyncVariantImage || 'always';
    const shouldSyncImage = imageSyncMode !== 'false'
      && imageSyncMode !== 'never'
      && (imageSyncMode !== 'interaction' || source === 'interaction');
    if (heroImage && option.dataset.imageUrl && shouldSyncImage) {
      heroImage.removeAttribute('srcset');
      heroImage.removeAttribute('sizes');
      heroImage.src = option.dataset.imageUrl;
    }

    const unitPrice = landing.querySelector('[data-bm-lp-unit-price]');
    const unitCount = Number(option.dataset.unitCount || 0);
    const priceCents = Number(option.dataset.priceCents || 0);
    if (unitPrice && unitCount > 0 && priceCents > 0) {
      const currency = landing.dataset.bmLpCurrency || 'USD';
      unitPrice.textContent = `${new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(priceCents / unitCount / 100)} per pick`;
    }
  };

  const variantOptionValue = (variant, position) => variant.getAttribute(`data-option-${position}`) || '';
  const selectedProductOption = (group) => (
    group.querySelector('select[data-bm-lp-product-option]')
    || group.querySelector('[data-bm-lp-product-option]:checked')
  );

  const syncProductOptions = (changedControl, source = 'initial') => {
    const landing = changedControl.closest('[data-bm-lp]');
    if (!landing) return;
    const variantSelect = landing.querySelector('[data-bm-lp-variant]');
    const groups = [...landing.querySelectorAll('[data-bm-lp-option-group]')];
    if (!variantSelect || !groups.length) return;

    const desired = new Map();
    groups.forEach((group) => {
      const selected = selectedProductOption(group);
      if (selected) desired.set(Number(group.dataset.optionPosition), selected.value);
    });

    const variants = [...variantSelect.options];
    let match = variants.find((variant) =>
      [...desired].every(([position, value]) => variantOptionValue(variant, position) === value)
    );

    if (!match) {
      const changedPosition = Number(changedControl.dataset.optionPosition);
      const available = variants.filter((variant) => variant.dataset.available === 'true');
      const changedMatches = available.filter((variant) =>
        variantOptionValue(variant, changedPosition) === changedControl.value
      );
      const candidates = changedMatches.length ? changedMatches : available;
      match = candidates.sort((left, right) => {
        const score = (variant) => [...desired].reduce(
          (total, [position, value]) => total + (variantOptionValue(variant, position) === value ? 1 : 0),
          0
        );
        return score(right) - score(left);
      })[0];
    }

    if (!match) return;
    variantSelect.value = match.value;
    groups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      const value = variantOptionValue(match, position);
      const select = group.querySelector('select[data-bm-lp-product-option]');
      const selected = select || [...group.querySelectorAll('[data-bm-lp-product-option]')]
        .find((control) => control.value === value);
      if (select) select.value = value;
      else if (selected) selected.checked = true;
    });

    groups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      group.querySelectorAll('[data-bm-lp-product-option]').forEach((control) => {
        const values = control.matches('select') ? [...control.options] : [control];
        values.forEach((valueControl) => {
          const possible = variants.some((variant) => {
            if (variant.dataset.available !== 'true') return false;
            if (variantOptionValue(variant, position) !== valueControl.value) return false;
            return groups.every((otherGroup) => {
              const otherPosition = Number(otherGroup.dataset.optionPosition);
              if (otherPosition >= position) return true;
              const selected = selectedProductOption(otherGroup);
              return !selected || variantOptionValue(variant, otherPosition) === selected.value;
            });
          });
          valueControl.disabled = !possible;
        });
      });
    });

    syncProductForm(variantSelect, source);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bm-lp-product-option]')) {
      syncProductOptions(event.target, 'interaction');
      return;
    }
    if (event.target.matches('[data-bm-lp-variant]')) syncProductForm(event.target, 'interaction');
  });

  document.querySelectorAll('[data-bm-lp-variant]').forEach(syncProductForm);
  document.querySelectorAll('[data-bm-lp-product-options]').forEach((options) => {
    const selected = options.querySelector('select[data-bm-lp-product-option]')
      || options.querySelector('[data-bm-lp-product-option]:checked');
    if (selected) syncProductOptions(selected);
  });

  let activeZoomTrigger = null;

  document.addEventListener('click', (event) => {
    const videoPoster = event.target.closest('[data-bm-lp-video-play]');
    if (videoPoster) {
      const frame = videoPoster.closest('.bm-lp__demo-frame');
      const template = frame && frame.querySelector('[data-bm-lp-video-template]');
      if (!frame || !template) return;
      frame.replaceChildren(template.content.cloneNode(true));
      frame.querySelector('iframe')?.focus();
      return;
    }

    const motionTrigger = event.target.closest('[data-bm-lp-motion-fullscreen]');
    if (motionTrigger) {
      const landing = motionTrigger.closest('[data-bm-lp]');
      const lightbox = landing && landing.querySelector('[data-bm-lp-motion-lightbox]');
      const video = lightbox && lightbox.querySelector('video');
      const sourceVideo = motionTrigger.closest('.bm-lp__motion-stage')?.querySelector('video');
      if (!lightbox || !video) return;
      activeZoomTrigger = motionTrigger;
      if (sourceVideo && Number.isFinite(sourceVideo.currentTime)) video.currentTime = sourceVideo.currentTime;
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      video.play().catch(() => {});
      return;
    }

    const zoomTrigger = event.target.closest('[data-bm-lp-zoom]');
    if (zoomTrigger) {
      const landing = zoomTrigger.closest('[data-bm-lp]');
      const lightbox = landing && landing.querySelector('[data-bm-lp-lightbox]');
      const image = lightbox && lightbox.querySelector('[data-bm-lp-lightbox-image]');
      const caption = lightbox && lightbox.querySelector('[data-bm-lp-lightbox-caption]');
      if (!lightbox || !image || !caption) return;

      activeZoomTrigger = zoomTrigger;
      image.src = zoomTrigger.dataset.bmLpZoomSrc;
      image.alt = zoomTrigger.dataset.bmLpZoomAlt || '';
      caption.textContent = zoomTrigger.dataset.bmLpZoomCaption || '';
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      return;
    }

    const closeButton = event.target.closest('[data-bm-lp-lightbox-close]');
    const lightbox = closeButton && closeButton.closest('[data-bm-lp-lightbox]');
    if (lightbox) lightbox.close();
  });

  document.querySelectorAll('[data-bm-lp-lightbox]').forEach((lightbox) => {
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('close', () => {
      const image = lightbox.querySelector('[data-bm-lp-lightbox-image]');
      const video = lightbox.querySelector('video');
      if (image) image.removeAttribute('src');
      if (video) video.pause();
      if (activeZoomTrigger) activeZoomTrigger.focus();
      activeZoomTrigger = null;
    });
  });

  document.querySelectorAll('[data-bm-lp-sticky-buy]').forEach((stickyBuy) => {
    const landing = stickyBuy.closest('[data-bm-lp]');
    const primaryBuy = landing && landing.querySelector('.bm-lp__buy-box');
    const finalBuy = landing && landing.querySelector('.bm-lp__final');
    if (!landing || !primaryBuy || !finalBuy) return;
    const finalVisibilityTarget = landing.classList.contains('bm-lp--product-volume-pedal')
      ? finalBuy.querySelector('.bm-lp__button') || finalBuy
      : finalBuy;

    let stickyFrame = null;
    const updateStickyBuy = () => {
      stickyFrame = null;
      const isMobile = window.matchMedia('(max-width: 640px)').matches;
      const primaryHasPassed = primaryBuy.getBoundingClientRect().bottom <= 0;
      const finalTargetRect = finalVisibilityTarget.getBoundingClientRect();
      const finalHasArrived = landing.classList.contains('bm-lp--product-volume-pedal')
        ? finalTargetRect.bottom <= window.innerHeight
        : finalTargetRect.top < window.innerHeight;
      const visible = isMobile && primaryHasPassed && !finalHasArrived;
      stickyBuy.classList.toggle('is-visible', visible);
      stickyBuy.setAttribute('aria-hidden', String(!visible));
    };
    const queueStickyUpdate = () => {
      if (stickyFrame !== null) return;
      stickyFrame = window.requestAnimationFrame(updateStickyBuy);
    };

    window.addEventListener('scroll', queueStickyUpdate, { passive: true });
    window.addEventListener('resize', queueStickyUpdate);
    updateStickyBuy();
  });

  const scrollCue = document.querySelector('[data-bm-lp-scroll-cue]');
  if (scrollCue) {
    const updateScrollCue = () => {
      const hidden = window.scrollY > 48;
      scrollCue.classList.toggle('is-hidden', hidden);
      scrollCue.setAttribute('aria-hidden', String(hidden));
    };
    scrollCue.addEventListener('click', () => {
      scrollCue.classList.add('is-hidden');
      scrollCue.setAttribute('aria-hidden', 'true');
    });
    window.addEventListener('scroll', updateScrollCue, { passive: true });
    updateScrollCue();
  }

  const popupSelectors = '#__pc_app, #pc-modal-backdrop, [class*="pc-campaign"], .ba-widget-overlay, .ba_widget_parent';
  const suppressSignupPopup = () => {
    document.querySelectorAll(popupSelectors).forEach((element) => {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('*').forEach((host) => {
      if (host.shadowRoot && host.shadowRoot.querySelector(popupSelectors)) {
        host.style.setProperty('display', 'none', 'important');
        host.setAttribute('aria-hidden', 'true');
      }
    });
  };

  let popupChecks = 0;
  const popupTimer = window.setInterval(() => {
    suppressSignupPopup();
    popupChecks += 1;
    if (popupChecks >= 24) window.clearInterval(popupTimer);
  }, 250);
  const popupObserver = new MutationObserver(suppressSignupPopup);
  if (document.body) popupObserver.observe(document.body, { childList: true, subtree: true });
  suppressSignupPopup();
})();

